"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeAnalytics = void 0;
var TypeAnalytics;

(function (TypeAnalytics) {
  /**
   * Firebase Analytics에 이벤트를 로깅해요
   * @required name   이벤트 이름
   * @required params 파라미터
   */
  TypeAnalytics["ReqAnalyticsLogEvent"] = "REQ.ANALYTICS.LOG_EVENT";
})(TypeAnalytics = exports.TypeAnalytics || (exports.TypeAnalytics = {}));